import { SpkAirdropContainer } from '@/features/spk/airdrop/SpkAirdropContainer'

export function SpkAirdrop() {
  return <SpkAirdropContainer />
}
